import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import Popper from "@mui/material/Popper";
import "./MentorRegistration.css";
import { Data } from "../VolunteerForm/Data";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InputAdornment from "@mui/material/InputAdornment";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import logo from "../../../img/logo_for-landingpage-3.png";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import { FormControl, Grid, FormLabel } from "@mui/material";
import { useNavigate, Outlet, useLocation } from "react-router";
import useAxios from "../../../api/useAxios";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MentorProfile from "./MentorProfile";
import mentor from "../../.../../../img/mentorImage-2.png";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocationFind } from "../LocationFind";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const exceptThisSymbols = ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"];

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const navigate = useNavigate();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function MentorRegistration() {
  const ref = React.createRef(null);
  const [focusout, setfocus] = useState();
  const axiosData = useAxios();
  const baseUrl = axiosData.defaults.baseURL;
  const [selectedIndustry, setSelectedIndustry] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t, i18n, ready } = useTranslation();
  const [formEmail, setFormEmail] = useState("");
  const [formEmailError, setFormEmailError] = useState("");
  const [emailErr, setEmailError] = useState(true);
  const [valid, setvalid] = useState(true);
  const [emailPopUp, setEmailPopUp] = useState(false);
  const [alerte, setalerte] = useState(false);
  const [industryArray, setIndustryArray] = useState();
  const [domainArray, setDomainArray] = useState();
  const fileInputField = useRef(null);
  const [data, setData] = useState(false);
  const [file, setFile] = useState("");
  const [resume, setResume] = useState("");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [mentorExperience, setMentorExperience] = useState("");
  const storedState = localStorage.getItem("currentLocationState");
  const storedCountry = localStorage.getItem("currentLocationCountry");
  const storedArea = localStorage.getItem("currentLocationArea");
  const storedPincode = localStorage.getItem("currentLocationPincode");

  const { locationData, locatioError } = useLocationFind();
  const location = useLocation();

  const MAX_FILE_SIZE = 1048576 * 10;
  const handleFileChange = (e) => {
    if (e.target.files[0].size > MAX_FILE_SIZE) {
      setFile("File is too large");
      setResume(false);
    } else {
      setResume(e.target.files[0]);
      setFile(e.target.files[0].name);
    }
    setData(e.target.files[0].size);
  };
  const deleteFile = () => {
    fileInputField.current.value = "";
    setFile(null);
    setData(null);
    setResume(null);
    formik.setFieldValue("fileUpload", null);
  };

  useEffect(() => {
    if (alerte !== false) {
      setEmailPopUp(true);
      setFormEmail("");
      formik.setFieldValue("email_id", "");
    }
    setalerte(false);
  }, [alerte]);
  const errors = {};

  const validate = async (values) => {
    const errors = {};
    if (!values.mobileNumber) {
      errors.mobileNumber = t("Mobile_Number_must_be_Required");
      setvalid(true);
    } else if (/^\d{9}$/.test(values.mobileNumber)) {
      setvalid(true);
    }

    return errors;
  };
  const filterOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    const startsWithInput = [];
    const containsInput = [];

    options.forEach((option) => {
      const optionLower = option.toLowerCase();
      if (optionLower.startsWith(inputValueLower)) {
        startsWithInput.push(option);
      } else if (optionLower.includes(inputValueLower)) {
        containsInput.push(option);
      }
    });

    return [...startsWithInput, ...containsInput];
  };

  const handleEmailChange = async (event) => {
    const email_id = event.target.value
      .replace(/[^a-z0-9@.]/gi, "")
      .toLowerCase();
    setFormEmail(email_id);
    if (!email_id) {
      setfocus(true);
      setFormEmailError(t("EmailId_must_be_Required"));
      errors.email_id = t("EmailId_must_be_Required");
      setEmailError(true);
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setfocus(false);
      setFormEmailError(t("Invalid_email_address4"));
      errors.email_id = t("Invalid_email_address4");
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setEmailError(true);
      setFormEmailError("");
      if (emailErr) {
        try {
          const response = await axiosData.post(`users/email`, {
            email_id: email_id,
          });
          if (response.status === 200) {
            setalerte(true);
            formik.setFieldValue("email_id", event.target.value);
          }
        } catch (error) { }
      }
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,}$/i.test(email_id)) {
      errors.email_id = t("Invalid_email_address4");
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,}$/i.test(email_id)) {
      setEmailError(true);
      if (emailErr) {
        try {
          const response = await axiosData.post(`users/email`, {
            email_id: email_id,
          });
          if (response.status === 200) {
            setalerte(true);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      MentorName: "",
      educationQualifications: "",
      Specialisation: "",
      officialAddress: "",
      mobileNumber: "",
      email_id: "",
      linkedInLink: "",
      areaOfExpertise: "",
      currentLocation: "",
      yearsOfExperience: "",
      currentEmployer: "",
      Designation: "",
      membershipInProfessional: "",
      professionalCertifications: "",
      CVUpload: null,
      Experience: "",
      mentorProfile: null,
      state: "",
      country: "",
    },
    validate,
    validationSchema: Yup.object({
      MentorName: Yup.string()
        .max(50, t("Must_be_50_characters_or_less1"))
        .required(t("Mentor_Name_must_be_Required")),
      mobileNumber: Yup.number()
        .min(6000000000, t("Not_Valid_Mobile_Number4!"))
        .max(9999999999, t("Not_Valid_Mobile_Number4!"))
        .required(t("Mobile_Number_must_be_Required")),
      email_id: Yup.string()
        .email(t("Invalid email address"))
        .required(t("EmailId_must_be_Required"))
        .matches(
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          t("Invalid_email_address")
        ),
      educationQualifications: Yup.string().required(
        t("educationQualifications_Required")
      ),
      Designation: Yup.string()
        .required(t("Designation_must_be_Required4"))
        .max(50, t("Must_be_50_characters_or_less4")),
      Specialisation: Yup.string().required(t("Specialisation_Required")),
      officialAddress: Yup.string().required(t("official_Address_Required")),
      linkedInLink: Yup.string()
        .required(t("linkedIn_Link_Required"))
        .matches(
          /https:\/\/www.linkedin.com\/.*$/,
          t("Invalid_LinkedIn_URL_format")
        ),
      areaOfExpertise: Yup.string().required(t("area_Of_Expertise_Required")),
      currentLocation: Yup.string().required(t("Other_Specify_Required")),
      yearsOfExperience: Yup.string().required(
        t("years_Of_Experience_Required")
      ),
      currentEmployer: Yup.string().required(t("current_Employer_Required")),
      membershipInProfessional: Yup.string().required(
        t("Membership_in_Professional_Societies")
      ),
      professionalCertifications: Yup.string().required(
        t("Professional_Certifications")
      ),
      Experience: Yup.string().required(t("years_Of_Experience_Required")),
    }),

    onSubmit: async (values) => {
      if (resume) {
        values.CVUpload = resume;
        values.email_id = formEmail;
      }
      if (uploadedImages) {
        values.mentorProfile = uploadedImages[0];
      }
      if (storedCountry) {
        values.state = storedState;
      }
      if (storedCountry) {
        values.country = storedCountry;
      }
      values.registertype = location.state?.registertype || "mentor";
      values.registerby = location.state?.registerby || "mentor";
      setIsSubmitting(true);
      await axiosData
        .post("mentor", values, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          axiosData
            .post(
              "users",
              {
                usertype: "mentor",
                status: "InActive",
                uniqueId: String(values.mobileNumber).concat("M"),
                password: values.mobileNumber,
                email_id: values.email_id,
                user_id: res.data.user_id,
              },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => { });
          setIsSubmitting(false);
          if (location.state.registertype === "home") {
            navigate(
              `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.ThankYou}`
            );
          } else {
            navigate(-1);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    },
  });
  const [focusb, setfocusb] = useState();
  const handleChange = (e) => {
    setfocusb(false);
    const { value } = e.target;
    if (value.length <= 10) {
      formik.handleChange(e);
    }
  };

  const theme = useTheme();
  const initialValue = parseInt(sessionStorage.getItem("selectedTab")) || 0;

  const [value, setValue] = useState(initialValue);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    sessionStorage.setItem("selectedTab", newValue);
  };

  const IndustryData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/seekerSettings`);
      const data = getOneAxios?.data?.industryData;

      if (data) {
        data.unshift("All");
        setIndustryArray(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const DomainData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/seekerSettings`);
      const data = getOneAxios?.data?.industryData;
      if (data) {
        setDomainArray(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const [getMentor, setGetMentor] = useState([]);
  const [noData, setNoData] = useState(false);
  const [searchSpecialisation, setsearchSpecialisation] = useState("All");
  const [mentorData, setMentorData] = useState(false);

  const getMentorData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/mentor`);
      const data = getOneAxios.data;
      if (data) {
        const statA = data.filter((i) => {
          return i.status === "A";
        });

        if (statA) {
          const sortedData = statA.sort((a, b) => {
            const SpecialisationSort = a.Specialisation.localeCompare(
              b.Specialisation
            );
            if (SpecialisationSort !== 0) {
              return SpecialisationSort;
            }
            return a.MentorName.localeCompare(b.MentorName);
          });
          setGetMentor(sortedData);
        }

        setMentorData(true);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const getMentorByDomain = async (value) => {
    try {
      setMentorData(false);
      const getOneAxios = await axiosData.post(`/mentor/domain`, value, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const data = getOneAxios.data;
      setMentorData(true);
      if (data) {
        const statA = data.filter((i) => {
          return i.status === "A";
        });
        const sortedData = statA.sort((a, b) => {
          return a.MentorName.localeCompare(b.MentorName);
        });
        setGetMentor(sortedData);
        setMentorData(true);
      }
      if (getOneAxios.status === 204) {
        setGetMentor([]);
        //setNoData(true);
        setMentorData(true);
      }

      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };
  const [experience, setExperience] = useState([]);
  const experienceData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/yearOfExperience`);
      const data = getOneAxios?.data?.experience;
      if (data) {
        setExperience(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  useEffect(() => {
    DomainData();
    experienceData();
    IndustryData();
    getMentorData();
  }, []);

  const [mentorPagination, setMentorPagination] = useState(8);

  const allLoadMore = () => {
    setMentorPagination(mentorPagination + 8);
  };

  const allLoadLess = () => {
    setMentorPagination(mentorPagination - 8);
  };

  if (ready && mentorData) {
    return (
      <ThemeProvider theme={theme}>
        <Dialog TransitionComponent={Transition} open={emailPopUp}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            {t("Email_Exits")}
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {t("This_Email_Id_already_exist")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setEmailPopUp(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog TransitionComponent={Transition} open={noData}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            Mentor Not Found
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              In this domain no mentor available
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setNoData(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
          <TabPanel
            sx={{
              bgcolor: "#f9fafb",
              width: "100%",
              minHeight: "100vh"
            }}
            value={value}
            index={0}
            dir={theme.direction}
          >
            <Box className="mentor-background-wrapper" sx={{ width: "100%", minHeight: "100vh", py: 8 }}>
              <CssBaseline />
              <Box className="mentor-registration-card" sx={{ position: "relative" }}>
                <Box sx={{ position: "absolute", top: 24, right: 32 }}>
                  <Typography variant="body2" sx={{ color: "#6b7280", fontWeight: 500, fontSize: "13px" }}>
                    Already a Member? <span onClick={() => setValue(1)} style={{ color: "#108fb2", cursor: "pointer", fontWeight: "bold" }}>View all Mentors</span>
                  </Typography>
                </Box>

                <form onSubmit={formik.handleSubmit}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      mb: 4,
                      pt: 1
                    }}
                  >
                    <Typography
                      component="h1"
                      variant="h5"
                      sx={{ color: "#111827", fontWeight: "bold", fontFamily: "Poppins-SemiBold, sans-serif", mb: 4, textAlign: "center" }}
                    >
                      {t("Mentor_Registration")}
                    </Typography>

                    <Grid container rowSpacing={2.5} columnSpacing={3} sx={{ mb: 2 }}>
                      {/* First row: Name + Photo Upload */}
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Mentor_Name")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t("Enter_Your_Name")}
                            id="MentorName"
                            name="MentorName"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z.,' ]/gi,
                                  ""
                                );
                                formik.setFieldValue("MentorName", value);
                              }
                            }}
                            value={formik.values.MentorName.replace(
                              /[^a-z'. ]/gi,
                              ""
                            )}
                            error={
                              formik.touched.MentorName &&
                              Boolean(formik.errors.MentorName)
                            }
                            helperText={
                              formik.touched.MentorName &&
                              formik.errors.MentorName
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Email_Id")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t("Enter_Your_Email_ID")}
                            id="email_id"
                            name="email_id"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              formik.handleChange(e);
                              handleEmailChange(e);
                            }}
                            value={formEmail}
                            onBlurCapture={() => {
                              setfocus(true);
                            }}
                            error={
                              formik.touched.email_id &&
                              focusout &&
                              Boolean(formik.errors.email_id)
                            }
                            helperText={
                              formik.touched.email_id &&
                              focusout &&
                              formik.errors.email_id
                            }
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Mobile_Number")}
                          </FormLabel>
                          <TextField
                            type="number"
                            required
                            fullWidth
                            placeholder={t("Enter_Your_Mobile_Number")}
                            id="mobileNumber"
                            name="mobileNumber"
                            onBlur={formik.handleBlur}
                            onChange={handleChange}
                            value={formik.values.mobileNumber}
                            onWheel={(e) => {
                              e.preventDefault();
                              e.target.blur();
                            }}
                            onKeyDown={(e) =>
                              exceptThisSymbols.includes(e.key) &&
                              e.preventDefault()
                            }
                            onBlurCapture={() => {
                              setfocusb(true);
                            }}
                            error={
                              formik.touched.mobileNumber &&
                              focusb &&
                              Boolean(formik.errors.mobileNumber)
                            }
                            helperText={
                              formik.touched.mobileNumber &&
                              focusb &&
                              formik.errors.mobileNumber
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("LinkedIn_Profile_Link")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t("Enter_LinkedIn_Profile_Link")}
                            id="linkedInLink"
                            name="linkedInLink"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.linkedInLink}
                            error={
                              formik.touched.linkedInLink &&
                              Boolean(formik.errors.linkedInLink)
                            }
                            helperText={
                              formik.touched.linkedInLink &&
                              formik.errors.linkedInLink
                            }
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Education_qualifications")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t(
                              "Enter_Education_qualifications"
                            )}
                            id="Education qualifications"
                            name="educationQualifications"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'.,/& ]/gi,
                                  ""
                                );
                                formik.setFieldValue(
                                  "educationQualifications",
                                  value
                                );
                              }
                            }}
                            value={formik.values.educationQualifications}
                            error={
                              formik.touched.educationQualifications &&
                              Boolean(formik.errors.educationQualifications)
                            }
                            helperText={
                              formik.touched.educationQualifications &&
                              formik.errors.educationQualifications
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        {domainArray && (
                          <FormControl fullWidth>
                            <FormLabel sx={{ fontWeight: "bold" }}>
                              {t("Specialisation/domain")}
                            </FormLabel>
                            <Autocomplete
                              disableClearable={
                                formik.values.Specialisation ? false : true
                              }
                              filterOptions={filterOptions}
                              id="industry"
                              name="Specialisation"
                              options={domainArray}
                              onBlur={formik.handleBlur}
                              onChange={(event, value) => {
                                setSelectedIndustry(value);
                                formik.setFieldValue(
                                  "Specialisation",
                                  value
                                );
                              }}
                              value={formik.values.Specialisation}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  id="Specialisation"
                                  placeholder={t(
                                    "Enter_Specialisation/domain"
                                  )}
                                  name="Specialisation"
                                  // onClick={() =>
                                  //   params.inputProps.onInputClick()
                                  // }
                                  error={
                                    formik.touched.Specialisation &&
                                    Boolean(formik.errors.Specialisation)
                                  }
                                  helperText={
                                    formik.touched.Specialisation &&
                                    formik.errors.Specialisation
                                  }
                                />
                              )}
                              onOpen={(event) => event.preventDefault()}
                              PopperComponent={({
                                children,
                                ...popperProps
                              }) => (
                                <Popper
                                  {...popperProps}
                                  placement="bottom-start"
                                  modifiers={{
                                    flip: {
                                      enabled: false,
                                    },
                                    preventOverflow: {
                                      enabled: true,
                                      boundariesElement: "scrollParent",
                                    },
                                  }}
                                  PopperProps={{
                                    placement: "bottom-start", // Placement set to "bottom-start"
                                  }}
                                >
                                  <Paper>{children}</Paper>
                                </Popper>
                              )}
                              ListboxProps={{
                                style: {
                                  maxHeight: "180px",
                                  overflowY: "auto",
                                },
                              }}
                            />
                          </FormControl>
                        )}
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Area_of_expertise")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t("Enter_Area_of_expertise")}
                            id="areaOfExpertise"
                            name="areaOfExpertise"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'., ]/gi,
                                  ""
                                );
                                formik.setFieldValue(
                                  "areaOfExpertise",
                                  value
                                );
                              }
                            }}
                            value={formik.values.areaOfExpertise}
                            error={
                              formik.touched.areaOfExpertise &&
                              Boolean(formik.errors.areaOfExpertise)
                            }
                            helperText={
                              formik.touched.areaOfExpertise &&
                              formik.errors.areaOfExpertise
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        {experience ? (
                          <FormControl fullWidth>
                            <FormLabel sx={{ fontWeight: "bold" }}>
                              {t("Years_of_experience_in_this_area")}
                            </FormLabel>
                            <Autocomplete
                              fullWidth
                              disableClearable={
                                formik.values.yearsOfExperience
                                  ? false
                                  : true
                              }
                              id="yearsOfExperience"
                              name="yearsOfExperience"
                              value={formik.values.yearsOfExperience}
                              onChange={(event, newValue) => {
                                formik.setFieldValue(
                                  "yearsOfExperience",
                                  newValue
                                );
                              }}
                              onBlur={formik.handleBlur}
                              options={experience}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  fullWidth
                                  name="yearsOfExperience"
                                  placeholder={t(
                                    "Enter_Years_of_experience_in_this_area"
                                  )}
                                  error={
                                    formik.touched.yearsOfExperience &&
                                    Boolean(formik.errors.yearsOfExperience)
                                  }
                                  helperText={
                                    formik.touched.yearsOfExperience &&
                                    formik.errors.yearsOfExperience
                                  }
                                />
                              )}
                              ListboxProps={{
                                style: {
                                  maxHeight: "180px",
                                  overflowY: "auto",
                                },
                              }}
                            />
                          </FormControl>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Current_Location1")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t("Enter_Current_Location1")}
                            id="currentLocation"
                            name="currentLocation"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'., ]/gi,
                                  ""
                                );
                                formik.setFieldValue(
                                  "currentLocation",
                                  value
                                );
                              }
                            }}
                            value={formik.values.currentLocation}
                            error={
                              formik.touched.currentLocation &&
                              Boolean(formik.errors.currentLocation)
                            }
                            helperText={
                              formik.touched.currentLocation &&
                              formik.errors.currentLocation
                            }
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Address-1")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t("Enter_Your_address")}
                            id="officialAddress"
                            name="officialAddress"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'.,/#&: ]/gi,
                                  ""
                                );
                                formik.setFieldValue(
                                  "officialAddress",
                                  value
                                );
                              }
                            }}
                            value={formik.values.officialAddress}
                            error={
                              formik.touched.officialAddress &&
                              Boolean(formik.errors.officialAddress)
                            }
                            helperText={
                              formik.touched.officialAddress &&
                              formik.errors.officialAddress
                            }
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Current_employer")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t("Enter_Current_employer")}
                            id="currentEmployer"
                            name="currentEmployer"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'.,&/ ]/gi,
                                  ""
                                );
                                formik.setFieldValue(
                                  "currentEmployer",
                                  value
                                );
                              }
                            }}
                            value={formik.values.currentEmployer}
                            error={
                              formik.touched.currentEmployer &&
                              Boolean(formik.errors.currentEmployer)
                            }
                            helperText={
                              formik.touched.currentEmployer &&
                              formik.errors.currentEmployer
                            }
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t("Designation(Current employer)")}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t(
                              "Enter_Designation(Current employer)"
                            )}
                            id="Designation"
                            name="Designation"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'.,&/ ]/gi,
                                  ""
                                );
                                formik.setFieldValue("Designation", value);
                              }
                            }}
                            value={formik.values.Designation}
                            error={
                              formik.touched.Designation &&
                              Boolean(formik.errors.Designation)
                            }
                            helperText={
                              formik.touched.Designation &&
                              formik.errors.Designation
                            }
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t(
                              "Membership_in_Professional_Societies/Associations"
                            )}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t(
                              "Enter_Membership_in_Professional_Societies/Associations"
                            )}
                            id="membershipInProfessional"
                            name="membershipInProfessional"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'.,&/ ]/gi,
                                  ""
                                );
                                formik.setFieldValue(
                                  "membershipInProfessional",
                                  value
                                );
                              }
                            }}
                            value={formik.values.membershipInProfessional}
                            error={
                              formik.touched.membershipInProfessional &&
                              Boolean(
                                formik.errors.membershipInProfessional
                              )
                            }
                            helperText={
                              formik.touched.membershipInProfessional &&
                              formik.errors.membershipInProfessional
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl fullWidth>
                          <FormLabel sx={{ fontWeight: "bold" }}>
                            {t(
                              "Other_Professional_Certifications_or_Trainings"
                            )}
                          </FormLabel>
                          <TextField
                            required
                            fullWidth
                            placeholder={t(
                              "Enter_Other_Professional_Certifications_or_Trainings"
                            )}
                            id="professionalCertifications"
                            name="professionalCertifications"
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              if (e) {
                                const value = e.target.value.replace(
                                  /[^a-z0-9'.,&/ ]/gi,
                                  ""
                                );
                                formik.setFieldValue(
                                  "professionalCertifications",
                                  value
                                );
                              }
                            }}
                            value={formik.values.professionalCertifications}
                            error={
                              formik.touched.professionalCertifications &&
                              Boolean(
                                formik.errors.professionalCertifications
                              )
                            }
                            helperText={
                              formik.touched.professionalCertifications &&
                              formik.errors.professionalCertifications
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <MentorProfile
                          uploadedImages={uploadedImages}
                          setUploadedImages={setUploadedImages}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <Box sx={{ width: "100%", minHeight: "165px" }}>
                          {file ? (
                            <div className="RenderImageBorder" style={{ position: "relative", border: "2px solid #108fb2", borderRadius: "12px", width: "100%", height: "165px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "#f0f9ff" }}>
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, padding: '16px 24px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(16, 143, 178, 0.1), 0 2px 4px -1px rgba(16, 143, 178, 0.06)' }}>
                                {file.toLowerCase().endsWith('.pdf') ? (
                                  <PictureAsPdfIcon sx={{ fontSize: 48, color: resume ? "#ef4444" : "#ef4444" }} />
                                ) : (
                                  <DescriptionIcon sx={{ fontSize: 48, color: resume ? "#108fb2" : "#108fb2" }} />
                                )}
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#334155", fontWeight: 600, textAlign: "center", wordBreak: "break-all", maxWidth: '200px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
                                >
                                  {file}
                                </Typography>
                              </Box>
                              <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                                <Tooltip title="Clear" arrow>
                                  <IconButton size="small" onClick={deleteFile} sx={{
                                    bgcolor: "white",
                                    width: "32px",
                                    height: "32px",
                                    boxShadow: "0 2px 8px rgba(239, 68, 68, 0.25)",
                                    border: "1px solid #fecaca",
                                    '&:hover': { bgcolor: "#fee2e2", transform: "scale(1.05)" },
                                    transition: "all 0.2s"
                                  }}>
                                    <CloseIcon sx={{ fontSize: "18px", color: "#ef4444" }} />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="MentorImageBorder"
                              onClick={() => {
                                if (!file) fileInputField.current.click();
                              }}
                              style={{ height: "165px" }}
                            >
                              <DriveFolderUploadIcon sx={{ fontSize: 40, color: "#9ca3af", mb: 0 }} />
                              <Typography variant="caption" sx={{ textAlign: "center", color: "#6b7280" }}>
                                Upload your CV
                              </Typography>
                            </div>
                          )}
                        </Box>
                        <Typography variant="caption" sx={{ color: resume ? "#6b7280" : "red", display: "block", textAlign: "center", mt: 1 }}>
                          (File must be &lt; 10Mb and .pdf/.doc/.docx only)
                        </Typography>
                        <input
                          className="resumefile"
                          id="file-upload"
                          type="file"
                          accept=".docx,.doc,.pdf,"
                          onChange={handleFileChange}
                          ref={fileInputField}
                          required
                          style={{ display: "none" }}
                        />
                      </Grid>
                    </Grid>
                    <FormControl
                      fullWidth
                      sx={{ mt: 3 }}
                      className="MentorReactQuill"
                    >
                      <FormLabel sx={{ fontWeight: "bold" }}>
                        {t("Experience_in_providing_guidance")}
                      </FormLabel>
                    </FormControl>
                    <Grid item xs={12} md={12} lg={12} sx={{ width: "100%" }}>
                      <ReactQuill
                        value={mentorExperience}
                        onChange={(value) => {
                          formik.setFieldValue("Experience", value);
                          setMentorExperience(value);
                        }}
                        modules={{
                          toolbar: [
                            ["bold", "italic", "underline", "strike"],
                            ["blockquote", "code-block"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                            [{ color: [] }, { background: [] }],
                            [{ font: [] }],
                            [{ align: [] }],
                            ["clean"],
                          ],
                        }}
                        error={
                          formik.touched.Experience &&
                          Boolean(formik.errors.Experience)
                        }
                        helperText={
                          formik.touched.Experience &&
                          formik.errors.Experience
                        }
                        placeholder={t(
                          "Experience_in_providing_guidance_placeholder"
                        )}
                        className="scrollable-container-Mentor"
                      />
                    </Grid>

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      className="mentor-submit-btn"
                      sx={{ mt: 3, mb: 2 }}
                      disabled={
                        resume &&
                          uploadedImages.length !== 0 &&
                          formik.isValid &&
                          formik.dirty &&
                          isSubmitting === false &&
                          (mentorExperience === "<p><br></p>") === false
                          ? false
                          : true
                      }
                    >
                      {t("Submit4")}
                      {isSubmitting && (
                        <CircularProgress
                          size={24}
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-12px",
                            marginLeft: "-12px",
                          }}
                        />
                      )}
                    </Button>


                  </Box>
                </form>
              </Box>
            </Box>
          </TabPanel >
          <TabPanel
            sx={{ bgcolor: "background.paper", width: "100%" }}
            value={value}
            index={1}
            dir={theme.direction}
          >
            <div className="mentor-list-container">
              <Typography className="mentor-header-title">
                Learn from our world class mentors
              </Typography>
              <Typography className="mentor-header-subtitle">
                Our amazing global mentors and experts from the tech industry to
                support and give you guidance in your career. One mentorship at a time
              </Typography>

              {mentorData ? (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px', width: '90%', maxWidth: '1200px', margin: '0 auto 20px auto' }}>
                    <Box>
                      {industryArray && (
                        <FormControl sx={{ width: "400px", backgroundColor: 'white', borderRadius: '4px' }}>
                          <Autocomplete
                            disableClearable={searchSpecialisation ? false : true}
                            filterOptions={filterOptions}
                            id="industry"
                            name="searchSpecialisation"
                            options={industryArray}
                            onChange={(event, value) => {
                              if (!value) {
                                getMentorData();
                              }
                              if (value === "All") {
                                getMentorData();
                              } else {
                                getMentorByDomain({ Specialisation: value });
                              }
                              setSelectedIndustry(value);
                              setsearchSpecialisation(value);
                            }}
                            value={searchSpecialisation}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                id="searchSpecialisation"
                                placeholder="Filter by Specialisation/Domain"
                                name="searchSpecialisation"
                                fullWidth
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      borderColor: "#108fb2",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "#0c6a85",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#108fb2",
                                    },
                                  },
                                }}
                              />
                            )}
                            onOpen={(event) => event.preventDefault()}
                            PopperComponent={({ children, ...popperProps }) => (
                              <Popper
                                {...popperProps}
                                placement="bottom-start"
                                modifiers={[
                                  {
                                    name: "flip",
                                    enabled: false,
                                  },
                                  {
                                    name: "preventOverflow",
                                    enabled: true,
                                    options: {
                                      boundariesElement: "scrollParent",
                                    },
                                  },
                                ]}
                              >
                                <Paper>{children}</Paper>
                              </Popper>
                            )}
                            ListboxProps={{
                              style: {
                                maxHeight: "150px",
                                overflowY: "auto",
                              },
                            }}
                          />
                        </FormControl>
                      )}
                    </Box>
                    <Box>
                      <Button
                        variant="contained"
                        onClick={() => setValue(0)}
                        className="mentor-submit-btn"
                        sx={{ width: 'auto', px: 4, margin: '0 !important' }}
                      >
                        Become a Mentor
                      </Button>
                    </Box>
                  </Box>

                  {getMentor.length === 0 ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "rgb(200, 200, 200)",
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      No mentor available in this domain
                    </div>
                  ) : (
                    <div className="new-mentor-grid">
                      {getMentor
                        ? getMentor.length !== 0
                          ? getMentor.slice(0, mentorPagination).map((item) => {
                            return (
                              <div
                                className="new-mentor-card"
                                key={item.email_id}
                                onClick={() => {
                                  navigate(
                                    ROUTINGDATA.LAND +
                                    ROUTINGDATA.MAIN +
                                    ROUTINGDATA.MENTORProfile,
                                    { state: { email_id: item.email_id } }
                                  );
                                }}
                              >
                                <img
                                  src={`${baseUrl}mentor/get/profile/${item.email_id}`}
                                  className="new-mentor-img"
                                  alt="img"
                                  onError={(e) => {
                                    e.target.src = mentor;
                                  }}
                                />
                                <div className="new-mentor-tag">Available</div>
                                <div className="new-mentor-overlay">
                                  <div className="new-mentor-info">
                                    <h4>{item.MentorName}</h4>
                                    <p>{item.Designation}</p>
                                    <p>{item.currentEmployer}</p>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                          : null
                        : null}
                    </div>
                  )}
                  <div className="pagination" style={{ paddingBottom: '40px' }}>
                    {mentorPagination > 8 && getMentor.length > 8 ? (
                      <Button variant="outlined" onClick={allLoadLess} sx={{ borderColor: '#108fb2', color: '#108fb2' }}>
                        See Less
                      </Button>
                    ) : null}
                    {mentorPagination < getMentor.length && (
                      <Button variant="contained" onClick={allLoadMore} sx={{ backgroundColor: '#108fb2', color: 'white', '&:hover': { backgroundColor: '#0c6a85' } }}>
                        See More
                      </Button>
                    )}
                  </div>
                </>
              ) : (
                <div
                  style={{
                    height: "70vh",
                    display: "grid",
                    placeItems: "center",
                  }}
                >
                  <div className="dots"></div>
                </div>
              )}
            </div>
          </TabPanel>
        </Box >

        <Outlet />
      </ThemeProvider >
    );
  } else {
    return (
      <div
        style={{
          height: "70vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div class="dots"></div>
      </div>
    );
  }
}
export default MentorRegistration;
